import { useMemo } from 'react';

import { keyOf } from '@Components/Grid/components/Table/formatters';
import column, { defaultColumnId, defaultActionsColumn, deleteAction } from '@Components/Grid/utils/column';

import DetailsEntity from './DetailsEntity';
import ReporterFormatter from './ReporterFormatter';
import SiteFormatter from './SiteFormatter';
import TextFormatter from './TextFormatter';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    column.accessor('userId', {
      header: 'Reporter',
      cell: info => <ReporterFormatter info={info} />,
    }),
    column.accessor('siteId', {
      header: 'Site',
      cell: info => <SiteFormatter info={info} />,
    }),
    column.accessor('errorDetails.pathname', {
      header: 'URL',
      cell: info => <TextFormatter info={info} />,
      enableSorting: false,
      size: 200,
    }),
    column.accessor('errorDetails.message', {
      header: 'Message',
      cell: info => <TextFormatter info={info} />,
      enableSorting: false,
      initialSize: 'max-w-[20vw]',
    }),
    defaultActionsColumn(detailsAction, deleteAction),
  ], [])
}

export function detailsAction(info) {
  return <DetailsEntity key={keyOf(info, 'details')} info={info} />
}
